import { render, staticRenderFns } from "./SobreNosotros.vue?vue&type=template&id=641992fc&scoped=true&"
import script from "./SobreNosotros.vue?vue&type=script&lang=js&"
export * from "./SobreNosotros.vue?vue&type=script&lang=js&"
import style0 from "./SobreNosotros.vue?vue&type=style&index=0&id=641992fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641992fc",
  null
  
)

export default component.exports